module.exports = __webpack_public_path__ + "img/btn1.f20e7eab.png";